<template>
  <div id="instant-registration-screen">
    <div class="loading-animation" v-if="isLoading">
      <lottie-player
        src="/static/images/animations/loading.json"
        background="transparent"
        speed="0.5"
        loop
        style="width: 300px; height: 300px"
        autoplay
      ></lottie-player>
    </div>
    <div v-else>
      <div v-if="hasError" class="error">
        <lottie-player
          src="/static/images/animations/error.json"
          background="transparent"
          speed="0.7"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
        <div class="error-text">
          {{$t('instantRegistrationScreen.errorText')}}
        </div>
         <base-button
              @click="continueFlow"
              :text="$t('instantRegistrionScreen.continueButtonText')"
              class="continue-button"
            />
      </div>
      <div v-else class="success">
        <lottie-player
          src="/static/images/animations/success.json"
          background="transparent"
          speed="0.7"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
        <div class="info-text">
          <div
            v-if="isLoading"
            class="loading-text"
            v-t="'instantRegistrationScreen.loading.text'"
          ></div>
          <div v-else class="success">
            <div
              class="success-text"
              v-t="'instantRegistrionScreen.success.text'"
            ></div>
            <div class="invite-block">
              This is your invitation url:
              <div class="invitation-url">
                {{`https://app.motivac.io/c/${user.company.invitationCode}`}}
                <span @click="copyUrl" class="copy-button">{{$t('instantRegistrationScreen.copyText')}}</span>
              </div>
              <div class="invitation-email">
                <a
                  :href="`mailto:?subject=Micro-feedback platform invitation&body=Dear team,%0D%0AI would like to invite you to the motivac.io system which is a micro-feedback platform with a built-in reward system.%0D%0A
You can join me at the following link: https://app.motivac.io/c/${user.company.invitationCode}`"
                  >{{$t('instantRegistrationScreen.emailInvitationText')}}</a
                >
              </div>
            </div>
            <base-button
              @click="continueFlow"
              :text="$t('instantRegistrionScreen.continueButtonText')"
              class="continue-button"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/shared/elements/BaseButton';
import { mapActions } from 'vuex';

export default {
  name: 'InstantRegistrationScreen',
  components: { BaseButton },
  data: () => ({
    isLoading: true,
    hasError: false,
    user: undefined,
  }),
  created() {
    this.instantRegistration(this.$route.query.email)
      .then((x) => {
        this.user = x.user;
        setTimeout(() => {
          this.isLoading = false;
        }, 3000);
      })
      .catch((err) => {
        setTimeout(() => {
          this.hasError = true;
          this.isLoading = false;
        }, 3000);
      });
  },
  methods: {
    ...mapActions({
      instantRegistration: 'users/instantRegistration',
    }),
    continueFlow() {
      window.location.href = '/';
    },
    copyUrl() {
      navigator.clipboard.writeText(`https://app.motivac.io/c/${this.user.company.invitationCode}`).then(
        () => {
          this.$eventBus.showToast({
            message: this.$t('instantRegistrationScreen.clipboardSuccess'),
          });
        },
        function (err) {
          console.error('Async: Could not copy text: ', err);
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#instant-registration-screen {
  display: flex;
  align-items: center;
  //justify-content: center;
  height: 100vh;
  flex-direction: column;
  .error {
    .continue-button {
      margin: 20px 0;
    }
  }
  .error,
  .success {
    display: flex;
    align-items: center;
    flex-direction: column;

    .info-text,
    .error-text {
      font-size: 1.2rem;
      max-width: 30vw;
      .loading-text {
      }
    }
    .invite-block {
      margin: 20px 0;
      border: 2px dashed #ccc;
      border-radius: 8px;
      padding: 20px;
      width: 100%;
      .invitation-url {
        margin: 5px 0;
        background-color: #eee;
        border-radius: 8px;
        position: relative;
        font-size: 0.6rem;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        .copy-button {
          position: absolute;
          right: 10px;
          cursor: pointer;
          font-size: 1rem;
          color: rgb(128, 175, 228);
        }
      }
      .continue-button {
        margin: 20px 0;
      }
    }
  }
}
</style>